import { Dispatcher } from '../../lib';
import { SelectionHandler } from './handler';

export default new Dispatcher('selection-handling', SelectionHandler);
